var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import * as React from 'react';
import Anchor from '@telia-front/anchor';
import Icon from '@telia-front/icon';
const Placeholder = (props) => {
    const { label } = props, rest = __rest(props, ["label"]);
    return (React.createElement(Anchor, Object.assign({}, rest, { className: "product-comparison__placeholder-link" }),
        React.createElement("div", { className: "product-comparison__placeholder-link-inner" },
            React.createElement(Icon, { modifiers: "#plus", className: "product-comparison__placeholder-link-icon" }),
            React.createElement("div", { className: "product-comparison__placeholder-link-label" }, label))));
};
export { Placeholder };
